<template>
<div>
      <div class="heading flex justify-between">
            <div v-if="activeReport.report">
                  <template v-if="showSaveReport && isReportEditable">
                        <input  type="text" class="hover:bg-gray-100 focus:bg-white focus:outline-none report_title rounded transition" maxlength="100" required v-model="reportName" @mouseover="hover = true" @mouseleave="hover = false" :style="'width:'+ inputLength(reportName.length) + 'ch'">
                        <feather type="edit-2" class="ml-2" v-show="hover" />
                  </template>
                  <h1 v-else>{{ reportName }}</h1>
            </div>
            <h1 v-else>{{ $t('select_report') }}</h1>
            <div class="tools" v-show="showSaveReport">
                  <feather class="p-2 hover:bg-gray-100 rounded cursor-pointer mb-3 transition" type="save" @click="save"/>
                  <feather class="p-2 hover:bg-gray-100 rounded cursor-pointer mb-3 transition" type="trash" @click="remove"/>
            </div>
      </div>
      <TableWrapper></TableWrapper>
      <report :show="true"></report>
</div>
</template>

<script>
import TableWrapper from '../components/select-report-tabs/TableWrapper'
import Report from '../components/Report'
import {mapGetters, mapMutations, mapActions} from 'vuex'
import ModalRemoveReport from '../components/ModalRemoveReport.vue'
import ModalService from '../modules/modals/services/modal.service'
import ModalSomethingWentWrong from "@/components/ModalSomethingWentWrong.vue";

export default {
      components: {
            TableWrapper,
            Report,
      },
      data(){
            return {
                  hover: null,
                  data: {},
                  isReportEditable: false
            }
      },
      computed: {
            ...mapGetters([
                  'activeReport',
                  'newReport',
                  'userType',
                  'reportsTypeList',
                  'findReport',
            ]),
            reportName: {
                  get() {
                        return this.newReport.name
                  },
                  set(value) {
                        if(value.length){
                              this.setNewReportItem({name: value})
                        }
                  }
            },
            showSaveReport(){
                  const index = this.userType.findIndex(type => type.id === this.newReport.type_id)
                  this.checkEditable()
                  if(index != -1) {
                        return true
                  } else {
                        return false
                  }
            }
      },
      watch: {
            reportsTypeList(newVal) {
                  const report_id = this.getUrlParam('id')
                  if(newVal.length && report_id){
                        const report = this.findReport(report_id)
                        if(report){
                              const report_type_id = report.type_id
                              this.selectReportType(report_type_id)
                              this.selectReport(report)
                              const payload = {
                                    backward_interval: report.backward_interval,
                                    columns: report.view_columns,
                                    filters: report.filters,
                                    group_by: report.group_by,
                                    stack_by: report.stack_by,
                                    order_by: report.order_by,
                                    aggregate: report.aggregate,
                                    additionalGroupBy: report.additionalGroupBy,
                                    date_from: report.date_from,
                                    date_to: report.date_to,
                                    cover_type: report.cover_type,
                                    chart_id: report.chart_id,
                                    map: report.map ? report.map : false,
                                    service: report.service.name
                              }
                              this.generateReport(payload).then(()=> {
                                    document.getElementById('report-result').scrollIntoView({behavior: 'smooth', block: 'start', inline: 'center'})
                              }).catch(()=>{
                                ModalService.open(ModalSomethingWentWrong)
                              })
                        }
                  }
            }
      },
      methods: {
            ...mapMutations({
                  setNewReportItem: 'setNewReportItem',
                  selectReportType: 'selectReportType', //pass only reportType ID
                  selectReport: 'selectReport', //pass
            }),
            ...mapActions({
                  saveReport: 'saveReport',
                  generateReport: 'generateReport',
            }),
            save(){
                  if(this.newReport.id && this.newReport.name){
                        this.saveReport()
                  }
            },
            remove(){
                  ModalService.open(ModalRemoveReport, {id: this.newReport.id, name: this.newReport.name});
            },
            inputLength(length){
                  let output = length;
                  if(length<10){
                        output += Math.abs(length/10 - 1)
                  }
                  return output
            },
            checkEditable(){
              if(this.activeReport.report !== null){
                const report = this.findReport((this.activeReport.report))
                if(report && (report.editPermission === null ||
                    report.editPermission === true)
                ) {
                  this.isReportEditable = true
                  return
                }
              }
              this.isReportEditable = false
            },
            getUrlParam(param){
                  const queryString = window.location.search;
                  const urlParams = new URLSearchParams(queryString);
                  if(urlParams.has(param) && urlParams.get(param)){
                        return urlParams.get(param)
                  }
            }
      },
}
</script>

<style lang="sass">
input.report_title
      @apply text-navy
      background-color: transparent
      font-style: normal
      font-weight: 600
      font-size: 32px
      line-height: 38px
      margin-bottom: 1rem
</style>